import { action } from 'satcheljs';
import BookingService from 'owa-service/lib/contract/BookingService';

/**
 * Action to save the availability profiles to the store.
 */
let saveProfiles = action(
    'SAVE_PROFILES',
    (profiles: Map<string, BookingService>, profilesOrder: string[]) => ({
        profiles,
        profilesOrder,
    })
);

export default saveProfiles;
